<template>
    <section class="padding-vertical-content" key="paso0" id="paso0">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="h1 text-uppercase">{{ $t('partido.buscar_abono', {abono: teatro.texto_abono}) }}</h2>
                </div>
                <div class="col-12 col-md-6">
                    <div class="row">
                        <div class="col-12">
                            <ContentOrLoading style="min-height: 250px;">
                                <BuscarAbonadoComponent 
                                    v-if="!buscando" 
                                    :abonado="abonado_search" 
                                    :abonadoSeleccionado="abonadoSeleccionado"
                                    v-on:terminado="buscarAbonado"
                                />
                            </ContentOrLoading>                            
                        </div>
                        <div class="col-12" v-if="error">
                            <section class="padding-vertical-content">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="alert alert-danger" role="alert">
                                                <div v-if="error != 'comprado'">
                                                    <template v-if="motivo == 'no_permitido'">
                                                        <p>
                                                            {{ $t('partido.fuera_rango', {abono: teatro.texto_abono}) }}
                                                        </p>
                                                    </template>
                                                    <template v-else-if="motivo == 'sancionado'">
                                                        <h4>
                                                            El abono ha sido sancionado hasta el {{ sancion_fecha_fin }}.
                                                        </h4>
                                                    </template>
                                                    <template v-else-if="motivo == 'ya_disponible'">
                                                        <p>
                                                            {{ $t('partido.ya_disponible_abonado') }}
                                                        </p>
                                                    </template>
                                                    <template v-else>
                                                        <h4>{{ error }}</h4>
                                                        <p>{{ $t('partido.incidencia_abono', { email: manager.email_incidencias ? manager.email_incidencias : 'info@compralaentrada.com', abonado: teatro.texto_abonado }) }}</p>
                                                        <p v-if="configuracion.hash_teatro == 'I0QtpDfZsTkgWKert1Gp'">
                                                            En el caso de que no exista tu número de abonado contacte con en club en:

                                                            Teléfono de contacto: 968.012.412
                                                            Email de contacto: {{ manager.email_incidencias || 'info@compralaentrada.com' }}
                                                        </p>
                                                    </template>
                                                </div>
                                                <p v-else>
                                                    <b>¡Ya activaste tu abono!</b>
                                                    <br/>
                                                    {{ $t('partido.recordamos', {abono: teatro.texto_abono}) }}
                                                    <br/>
                                                    <b>{{ $t('partido.cuestion', { email: manager.email_incidencias ? manager.email_incidencias : 'info@compralaentrada.com' }) }}</b>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-3">
                    <p class="text-center-sm">
                        <b>{{ $t('partido.activacion_abono') }}</b>
                    </p>
                    <ul class="text-justify-sm col-12 ml-1">
                        <li>{{ $t('partido.una_entrada', {abonado: teatro.texto_abonado}) }}</li>
                        <li>{{ $t('partido.abono_personal', {abono: teatro.texto_abono}) }}</li>
                        <li>{{ $t('partido.tiempo_suficiente') }}</li>
                    </ul>
                    <p class="text-center-sm"><b>{{ $t('partido.cuestion', { email: manager.email_incidencias ? manager.email_incidencias : 'info@compralaentrada.com' }) }}</b></p>
                </div>
                <div class="col-12 mt-3" v-if="mostrar_opciones">
                    <div class="row">
                        <div class="col-6">
                            <button class="button large-button btn-block effect-button" v-if="asiento_disponible" @click="bloquearAsientos()" :disabled="disabled">
                                <span>
                                    {{ $t('partido.continuar_asiento') }} 
                                    <span v-if="event.n_acompanantes > 0">
                                        {{ $t('partido.sin_acompanantes') }}
                                    </span>
                                </span>
                            </button>
                            <button class="button large-button btn-block btn-danger" v-else disabled><small>{{ $t('partido.asiento_no_disponible', {abono: teatro.texto_abono}) }}</small></button>
                        </div>
                        <div class="col-6">
                            <button class="button large-button btn-block effect-button" v-if="puede_cambiar" @click="seleccionarNuenoAsiento()" :disabled="disabled"><span>{{ $t('partido.nuevo_asiento') }} <span v-if="event.n_acompanantes > 0">{{ $t('partido.acompanantes') }}</span></span></button>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3" v-if="mostrar_precios">
                    <div class="row">
                        <div class="col-12">
                            <h3>{{ $t('partido.tipo_entrada') }}:</h3>
                        </div>
                        <div class="col-12 mt-3" v-for="(asiento, index) in asientos" :key="index">
                            <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                <select name="precio" v-model="precio_seleccionado" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :disabled="paso3">
                                    <option :value="null" selected="selected">{{ $t('partido.tipo_entrada') }}</option>
                                    <option v-for="(precio, index) in asiento.precios" :key="index" :value="precio">{{ precio.descripcion }} / {{ precio.precio | formatear_precio }}</option>
                                </select>
                            </ValidationProvider>
                        </div>
                        <div class="col-12 mt-3" v-if="precio_seleccionado">
                            <ContentOrLoading style="height: 400px">
                                <button v-if="!loading" class="button large-button btn-block effect-button" @click="bloquearAsientos" :disabled="disabled">{{ $t('partido.continuar') }}</button>
                            </ContentOrLoading>								
                        </div>								
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import BuscarAbonadoComponent from '@/components/frontend/events/compra/BuscarAbonadoComponent';

    export default {
        props: {
            event: {
                type: Object,
                required: true
            },
            sesion_id: {
                type: Number,
                requried: true
            },
            disabled: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                abonado_search: {
                    dni: null,
                    n_abonado: null
                },
                error: null,
                buscando: false,
                asientos: [],
                mostrar_opciones: false,
                asiento_disponible: null,
                datos_compradores: {},
                seccion_disponible: null,
                puede_cambiar: false,
                mostrar_precios: false,
                motivo: null,
                sancion_fecha_fin: null,
                zona: null,
                plaza: null,
                precio_seleccionado: null,
                abonadoSeleccionado: false
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        watch: {
            precio_seleccionado() {
                this.asientos[0].precio = {
                    'descripcion': this.precio_seleccionado.descripcion,
                    'gd': this.precio_seleccionado.price_management_online,
                    'gd_interno': this.precio_seleccionado.price_management_online_interno,
                    'id': this.precio_seleccionado.id,
                    'precio': this.precio_seleccionado.precio,
                    'precio_total': this.precio_seleccionado.precio_total
                };

                this.asientos[0].asiento.event_ticket_id = this.precio_seleccionado.id;

                this.$emit('setAsientos', this.asientos);
            },
        },
        methods: {
            buscarAbonado() {
                this.error = false;
                this.buscando = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado_search.dni,
                        n_abonado: this.abonado_search.n_abonado,
                        precio_reducido: true,
                        evento_id: this.event.id,
                        sesion_id: this.sesion_id
                    },
                    tid: this.configuracion.hash_teatro,
                    dni: this.abonado_search.dni,
                    n_abonado: this.abonado_search.n_abonado,
                    precio_reducido: true,
                    evento_id: this.event.id,
                    sesion_id: this.sesion_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                    if(res.data.error) {
                        this.reset();
                        this.error = res.data.error;
                        this.mostrar_opciones = false;
                    } else {
                        if(res.data.comprado) {
                            this.reset();
                            this.error = 'comprado';
                        } else {
                            this.abonadoSeleccionado = true;
                            if(res.data.asiento) {
                                this.asientos.push({
                                    'apellidos': res.data.info_abonado.apellidos,
                                    'asiento': null,
                                    'precio': null,
                                    'dni': '',
                                    'nombre': res.data.info_abonado.nombre,
                                    'telefono': ''
                                });
                            }                        

                            this.plaza = res.data.plaza;

                        
                            if(res.data.asiento_disponible && res.data.precio_reducido.length > 0) {
                                if(this.plaza) {
                                    this.plaza.precio_id = res.data.precio_reducido[0].id;
                                    this.plaza.precios = res.data.precio_reducido;
    
                                    this.zona = {
                                        'id': this.plaza.region_id,
                                        'name': this.plaza.region_name
                                    };
    
                                    this.$emit('setZona', this.zona);
                                }

                                this.asiento_disponible = true;

                                if(res.data.precio_reducido.length == 1 && this.asientos.length > 0) {
                                    this.asientos[0].precio = {
                                        'descripcion': res.data.precio_reducido[0].descripcion,
                                        'gd': res.data.precio_reducido[0].price_management_online,
                                        'gd_interno': res.data.precio_reducido[0].price_management_online_interno,
                                        'id': res.data.precio_reducido[0].id,
                                        'precio': res.data.precio_reducido[0].precio,
                                        'precio_total': res.data.precio_reducido[0].precio_total
                                    };
                                }

                                if(this.asientos.length > 0) {
                                    this.asientos[0].precios = res.data.precio_reducido;

                                    this.asientos[0].asiento = {
                                        'asiento': res.data.asiento.butaca,
                                        'event_ticket_id': res.data.precio_reducido[0].id,
                                        'fila': res.data.asiento.fila,
                                        'zona_id': res.data.asiento.zona_id,
                                        'zona_nombre': res.data.asiento.zona
                                    };

                                    this.$emit('setAsientos', this.asientos);
                                }                            
                            }
                        
                            this.$emit('setPlaza', this.plaza);

                            this.datos_compradores.id = res.data.info_abonado.id;
                            this.datos_compradores.email = res.data.info_abonado.email;
                            this.datos_compradores.nombre = res.data.info_abonado.nombre;
                            this.datos_compradores.apellidos = res.data.info_abonado.apellidos;

                            this.$emit('setDatos', this.datos_compradores);

                            if(res.data.asiento) {
                                this.zona = {
                                    'id': res.data.asiento.zona_id,
                                    'name': res.data.asiento.zona
                                };

                                this.$emit('setZona', this.zona);
                            }                        

                            this.puede_cambiar = res.data.puede_cambiar_asiento;
                            this.$emit('setSeccionDisponible', res.data.seccion_disponible);

                            //Si es el majadahonda no puede cambiar de asiento
                            if(this.configuracion.hash_teatro == 'xr6ASEHHSAjuAknejBfr') {
                                this.puede_cambiar = false;
                            }

                            if(!this.puede_cambiar && this.asiento_disponible) {
                                if(res.data.precio_reducido.length > 1) {
                                    this.mostrar_precios = true;
                                } else {
                                    this.bloquearAsientos();
                                }
                                
                            } else {
                                this.mostrar_opciones = true;
                            }
                        }
                    }

                    this.buscando = false;
                }).catch(error =>  {
                    this.motivo = error.response.data.motivo;
                    this.sancion_fecha_fin = error.response.data.fecha_fin;
                    this.error = 'El abonado no existe';
                    this.buscando = false;
                    this.mostrar_opciones = false;
                });
            },
            bloquearAsientos() {
                if(this.plaza) {
                    this.$emit('bloquearPlaza');
                } else {
                    this.$emit('bloquearAsientos');
                }
            },
            reset() {
                this.asientos = [];
                this.asiento_disponible = false;
                this.datos_compradores = {};
                this.zona = null;
                this.mostrar_opciones = false;
                this.plaza = null;

                this.$emit('setDatos', this.datos_compradores);
                this.$emit('setAsientos', this.asientos);
                this.$emit('setPlaza', this.plaza);
            },
            seleccionarNuenoAsiento() {
                this.$emit('seleccionarNuenoAsiento');
            }
        },
        components: {
            BuscarAbonadoComponent
        }
    }
</script>

<style scoped>
    @media (max-width: 1024px) {
        .large-button {
            width: 40wv !important;
        }
    }
</style>